import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-17" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-18" data-mp="pj6c83lngiqh">
        <div className="text-center" data-id="element-19" data-mp="avd0itzoq0d6">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-20" data-mp="aua4k7ni97qe">
            Seulement aujourd&apos;hui
          </span>
          <h2 className="mt-4 font-display text-[1.75rem] font-black leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-21" data-mp="1uete2ty9cqd">
            <span aria-hidden="true" data-id="element-22" data-mp="5w8o7uhgrmim">🎁 </span>Recevez les 5 Bonus{' '}
            <span className="italic text-grape" data-id="element-23" data-mp="3o1lg6tx6hpki">Stratégiques</span>
          </h2>
          <p className="mt-3 text-sm text-navy/60" data-id="element-24" data-mp="3o3porp60vcr4">
            Valeur totale :{' '}
            <span className="font-bold text-navy/40 line-through" data-id="element-25" data-mp="3t0yau0uak0xn">185€</span> —
            Inclus à <span className="font-bold text-tangerine" data-id="element-26" data-mp="1mars1i94k00w">0€</span> dans
            votre commande
          </p>
        </div>

        <ol className="mt-10 space-y-4" data-id="element-27" data-mp="1r78qb5a1furp">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-start gap-4 rounded-2xl bg-white p-5 shadow-[0_2px_10px_-6px_rgba(22,56,111,0.25)]" data-id="element-28" data-mp="3iclojv2wsoze" data-mpi={index}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-tangerine font-display text-sm font-bold text-white" data-id="element-29" data-mp="3r68ev5ocl017">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-16 w-12 shrink-0 rounded-md object-cover shadow-[0_2px_8px_-4px_rgba(22,56,111,0.4)]" data-id="element-30" data-mp="2zg3xzgzsqv4q" />
              <div data-id="element-31" data-mp="38htlibqk59x8">
                <h3 className="font-display text-sm font-bold leading-snug text-navy" data-id="element-32" data-mp="38dw2rr7w6kdv">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 text-xs leading-relaxed text-navy/60" data-id="element-33" data-mp="np8dsosv5pmy">
                  {bonus.text}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}